module.exports = __webpack_public_path__ + "img/img_left_nav_vip_hover.15d2c61c.svg";